<div id="education-overlay" class="bottom-center-overlay bgc-glass" [ngStyle]="overlayStyles">
  @if (getRoleDisplayName() !== '') {
    <p class="larger-font">
      We suggest the following learning paths for
      <b class="brand-primary-navy"><span></span>{{ getRoleDisplayName() }}</b> like you.
    </p>
    <app-education-course-list [role]="role" (linkClick)="onLinkClick()"></app-education-course-list>
  } @else {
    <span class="larger-font">
      We're very proud of our
      <a
        class="overlay-link"
        (click)="onLinkClick()"
        href="https://orchestrators.genesys.com/education?product=genesys-cloud-cx"
        target="_blank"
        title="Education and Certification link">
        education and certification</a
      >
      offerings. Be sure to check out our
      <a
        class="overlay-link"
        (click)="onLinkClick()"
        href="https://beyond.genesys.com/explore/learning-path/home"
        target="_blank"
        title="Learning Paths link">
        Learning Paths </a
      >.
    </span>
  }
</div>
